// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__38sp6","content":"LayoutSettings_content__3AdD2"};